
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.669 12.644V5.906H4.156v14.35h9.1","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.494 10.981c.284-.31.44-.716.437-1.137a1.479 1.479 0 00-.262-.875 1.365 1.365 0 00-.7-.525 1.514 1.514 0 00-.875-.088 1.216 1.216 0 00-.875.438 1.181 1.181 0 00-.438.787c-.063.294-.032.6.088.875.103.306.323.557.612.7.257.178.563.27.875.263a1.454 1.454 0 001.138-.438z","fill":"#fff"}}),_c('path',{attrs:{"d":"M19.504 22.934a4.831 4.831 0 004.733-5.775 4.82 4.82 0 10-8.146 4.375 4.796 4.796 0 003.412 1.4z","fill":"#38B449"}}),_c('path',{attrs:{"d":"M17.999 17.99l1.085 1.12L21 17.15","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    